import axios from "@app/Security/AxiosAuthentication";
import ApiEndpoints from "@app/utils/ApiEndpoints";
import UserFpuAccessInterface from "@app/Interface/UserFpuAccessInterface";
import RegisterUserInterface from "@app/Interface/RegisterUserInterface";
import RevokeUserInterface from "@app/Interface/RevokeUserInterface";
import RollbarHelper from "@app/utils/RollbarHelper";

/**
 * Helper class for API middleware endpoint 
 * /api/user-fpu-accessses
 */
export default class UserFpuAccessHelper {

    static updateUserRoleAccess = async (accessData: UserFpuAccessInterface): Promise<number | boolean> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const url = baseUrl + ApiEndpoints.USER_FPU_ACCESS_SAVE;

        return axios.post(url, accessData, {
            withCredentials: true
        })
            .then(response => {

                return response.status;

            })
            .catch(error => {

                RollbarHelper.logRequestError(error, "updateUserRoleAccess()");

                return false;

            });

    }

    static registerUser = async (accessData: RegisterUserInterface): Promise<number | boolean> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const url = baseUrl + ApiEndpoints.REGISTER_USER;

        return axios.post(url, accessData, {
            withCredentials: true
        })
            .then(response => {

                return response.status;

            })
            .catch(error => {

                RollbarHelper.logRequestError(error, "registerUser()");

                return false;

            });

    }

    static revokeUser = async (data: RevokeUserInterface): Promise<number | boolean> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const url = baseUrl + ApiEndpoints.REVOKE_USER;

        return axios.post(url, data, {
            withCredentials: true
        })
            .then(response => {

                return response.status;

            })
            .catch(error => {

                RollbarHelper.logRequestError(error, "revokeUser()");

                return false;

            });

    }

    /**
     * Resend Invite, non-asycn
     * 
     * @param email string Email address of person receiving the invite
     * @param fpu   FPU ID the user was invited to.
     */
    static resendInvite = async (email: string, fpu: number): Promise<boolean> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const url = baseUrl + ApiEndpoints.USER_RESEND_INVITE;

        const data = {
            emailAddress: email,
            fpuID: fpu
        };

        const config = {
            withCredentials: true
        };

        try {

            axios.post(url, data, config);

            return true;

        } catch (error) {

            // TODO: replace with rollbar
            console.info("url: ", url);

            console.info("resendInvite error: ", error);

            return false;
        }


    }

}